import { ConnectionRefusedMessage } from "../BusMessages";
import { wrapMessage, getRegExpForSubscriptionPattern } from "flavr-common";
export class BusWorker {
    constructor() {
        // all the connected workers go here
        this.ports = new Map();
        // every worker could have one or more subscription patterns
        this.subscriptions = new Map();
        this.patternToWorkerIds = new Map();
    }
    getWorkersForPattern(pattern) {
        let workers = this.patternToWorkerIds.get(pattern);
        if (workers !== undefined)
            return workers;
        workers = [];
        for (const [workerId, patterns] of this.subscriptions) {
            for (const p of patterns) {
                if (!p.regexp.test(pattern))
                    continue;
                workers.push(workerId);
                // no need to match other patterns of this worker
                break;
            }
        }
        this.patternToWorkerIds.set(pattern, workers);
        return workers;
    }
    onWorkerDied(msg) {
        // Worker died, remove port
        this.ports.delete(msg.workerId);
        // remove all subscriptions for this worker
        this.subscriptions.delete(msg.workerId);
        this.patternToWorkerIds.clear();
    }
    onWorkerConnected(workerId, port) {
        if (this.ports.has(workerId)) {
            const msg = new ConnectionRefusedMessage(`Worker with id '${workerId}' already connected`);
            port.postMessage(wrapMessage(msg, "bus", "bus", Date.now()));
            port.close();
            return;
        }
        this.ports.set(workerId, port);
    }
    sendMessageTo(workerId, data) {
        const p = this.ports.get(workerId);
        if (p !== undefined) {
            p.postMessage(data);
        }
        else {
            throw new Error(`worker not found ${workerId}`);
        }
    }
    broadcastMessage(pattern, data, sourceWorkerId) {
        const workerIds = this.getWorkersForPattern(pattern);
        for (const workerId of workerIds) {
            if (workerId === sourceWorkerId)
                continue;
            const p = this.ports.get(workerId);
            if (p === undefined)
                continue;
            p.postMessage(data);
        }
    }
    sendBufferTo(toWorkerId, sourceWorkerId, pattern, timeStamp, data, askId, targetWorkerId) {
        const p = this.ports.get(toWorkerId);
        if (p === undefined)
            throw new Error(`worker not found ${toWorkerId}`);
        // For one worker post the reference (transferable ArrayBuffer)
        p.postMessage({
            pattern,
            workerId: sourceWorkerId,
            moduleId: data.moduleId,
            timeStamp,
            askId,
            targetWorkerId,
            buf: data.buf
        }, [data.buf]);
    }
    broadcastBuffer(pattern, timeStamp, data, sourceWorkerId, askId) {
        const workerIds = this.getWorkersForPattern(pattern);
        if (workerIds.length === 0)
            return;
        if (workerIds.length === 1) {
            const workerId = workerIds[0];
            if (workerId === sourceWorkerId)
                return;
            this.sendBufferTo(workerId, sourceWorkerId, pattern, timeStamp, data, askId);
            return;
        }
        for (const workerId of workerIds) {
            if (workerId === sourceWorkerId)
                continue;
            const p = this.ports.get(workerId);
            if (p === undefined)
                return;
            // For more workers use the structured clone algorithm
            p.postMessage({
                pattern,
                workerId: sourceWorkerId,
                moduleId: data.moduleId,
                timeStamp,
                askId,
                buf: data.buf
            });
        }
    }
    sendTransferTo(toWorkerId, transfer, meta) {
        const p = this.ports.get(toWorkerId);
        if (p === undefined)
            throw new Error(`worker not found ${toWorkerId}`);
        p.postMessage({
            meta
        }, transfer);
    }
    sendDataTransferTo(toWorkerId, data, transfer) {
        const p = this.ports.get(toWorkerId);
        if (p === undefined)
            throw new Error(`worker not found ${toWorkerId}`);
        p.postMessage(data, transfer);
    }
    updateSubscriptions(subscribe, workerId) {
        var _a, _b;
        this.patternToWorkerIds.clear();
        if (!subscribe.unsubscribe) {
            // subscribe
            const existing = (_a = this.subscriptions.get(workerId)) !== null && _a !== void 0 ? _a : [];
            for (const pattern of subscribe.pattern) {
                const p = existing.find((it) => it.pattern === pattern);
                if (p !== undefined) {
                    p.refcount++;
                }
                else {
                    existing.push({
                        pattern,
                        refcount: 1,
                        regexp: getRegExpForSubscriptionPattern(pattern)
                    });
                }
            }
            this.subscriptions.set(workerId, existing);
        }
        else {
            // unsubscribe
            const existing = (_b = this.subscriptions.get(workerId)) !== null && _b !== void 0 ? _b : [];
            // remove matching pattern
            for (const pattern of subscribe.pattern) {
                const p = existing.find((it) => it.pattern === pattern);
                if (p !== undefined) {
                    p.refcount--;
                }
            }
            this.subscriptions.set(workerId, existing.filter((it) => it.refcount > 0));
        }
    }
}
